<template>
  <div class="requirement-analysis">
    <!-- 组件内容 -->
    <div style="width: 1080px;padding: 40px 0 65px" class="flex-column items-center justify-center">
      <div class="title-box">
        <div class="ai-icon"></div>
        <div class="title-icon"></div>
      </div>
      <div class="title-message">上传需求，帮您快速拆解需求寻找技术成果</div>
      <div class="content-bg">
        <!-- 旧版 v1 -->
        <div class="content-box" v-if="false">
          <!-- 左侧 -->
          <div class="input-content flex-column items-center justify-between" style="padding-right: 14px" :style="{width: this.questionId ? '50%' : '100%'}" :class="{'question-textarea': questionId}">
            <el-input
              type="textarea"
              resize="none"
              placeholder="您可以在这里描述您的需求，例如：
需求面向产业方向是：xxxxxxxxxxxxxxx；主要解决问题是：xxxxxxxxxxxxxxx；需求方案描述：xxxxxxxxxxxxxxxxxx；
请推荐几家潜在的可以合作的机构。"
              v-model="textarea"
            />
            <div class="upload-btn" v-if="questionId">
              <el-button :loading="keyWordLoading" @click="getDemandDisassembly" :style="{padding: this.questionId ? '8px 14px !important' : '10px 14px !important'}" >立即识别</el-button>
            </div>
          </div>
          <!-- 分割线 -->
          <div style="height:100%;width: 0;background: transparent;border-left: 1px dashed rgba(0,0,0,0.2)" v-if="questionId"></div>
          <!-- 右侧 -->
          <div class="input-content flex-column items-center justify-between" style="padding-left: 14px;padding-right: 14px" v-if="questionId">
            <div class="right-top" style="width: 100%;flex-shrink: 0">
              <div style="color: #0226E0" class="flex items-center">
                <img src="@/assets/images/achievement/keywordContent.png" :height="13" :width="15" style="margin-right: 5px" alt=""/>
                基于大模型的技术需求拆解
              </div>
              <div class="descContent" ref="descContent" style="max-height: 186px;padding: 7px 0">
                <div class="field-content" style="padding: 0;max-height: 186px;overflow-y: auto" v-if="keywordList && keywordList.length">
                  {{ keywordList[0].technology }}
                </div>
                <div v-else style="color: #00000E45;font-size: 14px;padding-top: 10px">先在左侧输入内容，再点击「立即识别」，大模型将自动拆解您的需求～</div>
              </div>
              <div class="keyword-input">
                <div style="font-size: 14px;height: 14px;margin: 10px 0 6px;color: #181F33">关键词：</div>
                <div class="keyword-box" :style="{ maxHeight: keywordHeight + 'px' }">
                  <div
                    class="tag-item"
                    v-for="(tag,ind) in keywordTags"
                    :key="ind"
                    :style="{paddingRight: isEdit ? '16px' : '8px'}"
                  >
                    <span class="" v-if="!isEdit">{{ tag.tagName }}</span>
                    <el-input v-model="tag.tagName" size="mini" style="width: 86px" v-else />
                    <el-popconfirm
                      v-if="isEdit"
                      placement="top"
                      confirm-button-text='确认'
                      cancel-button-text='取消'
                      icon="el-icon-info"
                      icon-color="red"
                      popper-class="keyword-confirm-delete"
                      title="确定删除吗？"
                      @confirm="handleTagClose(tag)"
                    >
                      <i class="el-icon-close" slot="reference"></i>
                    </el-popconfirm>
                  </div>

                  <span style="display: inline-block;height: 28px" v-if="isEdit">
                    <span class="flex items-center" style="flex-wrap: nowrap;height: 28px;" v-if="tagVisible">
                      <el-input
                        class="input-new-tag"
                        v-model.trim="tagValue"
                        ref="saveTagInput"
                        size="mini"
                        placeholder="请输入关键词"
                      />
                      <span class="operation-btn pointer" style="color: #0226E0;margin-left: 8px" @click="handleTagConfirm">确定</span>
                      <span class="operation-btn pointer" style="color: rgba(0,0,0,0.65)" @click="()=>{ tagValue = '';tagVisible = false; }">取消</span>
                    </span>
                    <span class="button-new-tag" v-else>
                      <el-button type="text" @click="showInput">+ 添加</el-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!-- 生成报告 -->
            <div class="goDetails-btn flex items-center justify-between" style="width: 100%;flex-shrink: 0">
              <div class="flex items-center update-btn no-wrap">
                请确保关键词是否正确？
                <el-button type="text" style="color: #0226E0" @click="handleEdit" :loading="updateLoading">{{ !isEdit ? '点击修改' : '点击保存' }}</el-button>
              </div>
              <span class="submit-btn">
                <el-button :loading="false" @click="goDetail">生成报告</el-button>
              </span>
            </div>
          </div>
        </div>

        <!-- 新版 v3 -->
        <div class="content-box">
          <!-- 默认页面 -->
          <div
            v-if="disassemblyStaus !== 'SUCCESS'"
            v-loading="keyWordLoading"
            element-loading-background="rgba(255, 255, 255, 0.3)"
            class="default-view flex items-center"
          >
            <div class="input-content flex-column items-center justify-between">
              <el-input
                type="textarea"
                resize="none"
                placeholder="您可以在这里描述您的需求，例如：
需求面向产业方向是：xxxxxxxxxxxxxxx；
主要解决问题是：xxxxxxxxxxxxxxx；
需求方案描述：xxxxxxxxxxxxxxx；
请推荐几家潜在的可以合作的机构；
建议1000字以内。"
                v-model="textarea"
                maxlength="1000"
              />
            </div>
            <div class="upload-file">
              <el-upload
                class="upload-demo"
                drag
                action="null"
                :multiple="false"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="handleFileChange"
                accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx"
              >
                <div class="flex-column items-center justify-center" style="height: 100%" v-if="!uploadFile">
                  <img width="40" height="32" :src="uploadIcon" alt="">
                  <div class="upload_text">AI文档解析，<span>点击上传</span></div>
                  <p style="font-size: 12px;color: rgba(0,0,0,0.45);padding-top: 10px">建议上传文件不超过20MB</p>
                  <div class="upload-line"><div></div>上传格式<div></div></div>
                  <div class="flex justify-center">
                    <div class="upload-img">
                      <img width="24" height="22" :src="word" alt="">
                      <img width="24" height="22" :src="excel" alt="">
                      <img width="22" height="22" :src="ppt" alt="">
                      <img width="22" height="22" :src="pdf" alt="">
                    </div>
                  </div>
                </div>
                <div class="flex-column items-center justify-center show-file" v-else>
                  <div class="flex-column items-center" style="cursor: default" @click.stop="()=>{}">
                    <img width="44" height="46" :src="fileType" alt="">
                    <p class="file-name ellipsis">{{ uploadFile.name }}</p>
                  </div>
                  <div class="upload-success">
                    <i class="el-icon-upload-success el-icon-circle-check"></i>上传成功
                  </div>
                  <div class="operation-btn">
                    <span>重新上传</span>
                    <span @click.stop="deleteFile">删除</span>
                  </div>
                </div>
              </el-upload>
            </div>
          </div>
          <!-- 需求拆分 -->
          <div class="disassembly-view flex items-center" v-else-if="questionId && disassemblyStaus === 'SUCCESS'">
            <!-- 左侧 -->
            <div class="input-content flex-column items-center justify-between">
              <div class="back_radio relative">
                <div class="flex items-center justify-center type-radio">
                  <template v-if="textObj.input && textObj.file">
                    <span :class="{ active: current === 'input' }" @click="current = 'input'">手动输入</span>
                    <i>|</i>
                    <span :class="{ active: current === 'file'}" @click="current = 'file'">文件解析</span>
                  </template>
                  <template v-if="textObj.input && !textObj.file">
                    <span :class="{ active: current === 'input' }" style="cursor: text">手动输入</span>
                  </template>
                  <template v-if="!textObj.input && textObj.file">
                    <span :class="{ active: current === 'file' }" style="cursor: text">文件解析</span>
                  </template>
                </div>
                <i class="el-icon-arrow-left absolute pointer" @click="handleBack">返回</i>
              </div>
              <el-input
                v-if="current === 'input'"
                type="textarea"
                resize="none"
                placeholder=""
                :value="textObj[current]"
                disabled
              />
              <p class="markdown-body" style="width: 489px;height: calc(100% - 30px);overflow: auto" v-html="textObj[current]" v-if="current === 'file'" />
            </div>
            <!-- 分割线 -->
            <div style="height:100%;width: 0;background: transparent;border-left: 1px dashed rgba(0,0,0,0.2)"></div>
            <!-- 右侧 -->
            <div class="input-content flex-column items-center justify-between" style="padding-left: 14px;padding-right: 14px">
              <div class="right-top" style="width: 100%;flex-shrink: 0">
                <div style="color: #0226E0" class="flex items-center">
                  <img src="@/assets/images/achievement/keywordContent.png" :height="13" :width="15" style="margin-right: 5px" alt=""/>
                  基于大模型的技术需求拆解
                </div>
                <div class="descContent" ref="descContent" style="max-height: 186px;padding: 7px 0">
                  <div class="field-content" style="padding: 0;max-height: 186px;overflow-y: auto" v-if="keywordList && keywordList.length">
                    {{ keywordList[0].technology }}
                  </div>
                  <div v-else style="color: #00000E45;font-size: 13px;padding-top: 10px">先输入需求描述或上传文件，再点击「立即识别」，大模型将自动拆解您的需求～</div>
                </div>
                <div class="keyword-input">
                  <div style="font-size: 14px;height: 14px;margin: 10px 0 6px;color: #181F33">关键词：</div>
                  <div class="keyword-box" :style="{ maxHeight: keywordHeight + 'px' }">
                    <div
                      class="tag-item"
                      v-for="(tag,ind) in keywordTags"
                      :key="ind"
                      :style="{paddingRight: isEdit ? '16px' : '8px'}"
                    >
                      <span class="" v-if="!isEdit">{{ tag.tagName }}</span>
                      <el-input v-model="tag.tagName" size="mini" style="width: 86px" v-else />
                      <el-popconfirm
                        v-if="isEdit"
                        placement="top"
                        confirm-button-text='确认'
                        cancel-button-text='取消'
                        icon="el-icon-info"
                        icon-color="red"
                        popper-class="keyword-confirm-delete"
                        title="确定删除吗？"
                        @confirm="handleTagClose(tag)"
                      >
                        <i class="el-icon-close" slot="reference"></i>
                      </el-popconfirm>
                    </div>

                    <span style="display: inline-block;height: 28px" v-if="isEdit">
                    <span class="flex items-center" style="flex-wrap: nowrap;height: 28px;" v-if="tagVisible">
                      <el-input
                        class="input-new-tag"
                        v-model.trim="tagValue"
                        ref="saveTagInput"
                        size="mini"
                        placeholder="请输入关键词"
                      />
                      <span class="operation-btn pointer" style="color: #0226E0;margin-left: 8px" @click="handleTagConfirm">确定</span>
                      <span class="operation-btn pointer" style="color: rgba(0,0,0,0.65)" @click="()=>{ tagValue = '';tagVisible = false; }">取消</span>
                    </span>
                    <span class="button-new-tag" v-else>
                      <el-button type="text" @click="showInput">+ 添加</el-button>
                    </span>
                  </span>
                  </div>
                </div>
              </div>
              <!-- 生成报告 -->
              <div class="goDetails-btn flex items-center justify-between" style="width: 100%;flex-shrink: 0">
                <div class="flex items-center update-btn no-wrap">
                  请确保关键词是否正确？
                  <el-button type="text" style="color: #0226E0" @click="handleEdit" :loading="updateLoading">{{ !isEdit ? '点击修改' : '点击保存' }}</el-button>
                </div>
                <span class="submit-btn">
                <el-button :loading="false" @click="goDetail">生成报告</el-button>
              </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="upload-btn-primary">
        <div style="height: 60px;" v-if="disassemblyStaus === 'SUCCESS'"></div>
<!--        <el-button :loading="keyWordLoading" @click="getDemandDisassembly" v-else>立即识别</el-button>-->
        <el-button :loading="keyWordLoading" @click="getDemandDisassembly_V3" v-else>立即识别</el-button>
      </div>
    </div>
    <!-- 付费弹窗 -->
    <paymentDialog ref="requirementPayment" payType="需求分析" />
  </div>
</template>

<script>
import uploadIcon from '@/assets/images/common/upload-icon.png';
import ppt from '@/assets/images/achievement/achievement-ppt.png';
import pdf from '@/assets/images/achievement/achievement-pdf.png';
import word from '@/assets/images/achievement/achievement-word.png';
import excel from '@/assets/images/achievement/achievement-excel.png';
import defaultFile from '@/assets/images/achievement/default-file.png';
import { requirementIndexMixin } from '@/mixin/requirementAnalysis/requirementMixin';
import paymentDialog from '@/components/PaymentDialog.vue';

export default {
  name: 'requirementAnalysis',
  mixins: [ requirementIndexMixin ],
  components: { paymentDialog },
  props: {},
  data() {
    return {
      uploadIcon,
      ppt,
      pdf,
      word,
      excel,
      defaultFile,
    }
  },
  created() {},
  methods: {}
};
</script>

<style scoped lang="less">

.markdown-body {
  font-weight: 400 !important;
  color: #333333 !important;
  font-size: 14px !important;
  /deep/ table {
    overflow-x: auto;
    thead {
      th {
        min-width: 90px !important;
        text-align: center !important;
      }
    }
    tbody {
      td {
        text-align: center !important;
      }
    }
  }
}

.requirement-analysis {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  justify-content: center;
  background-image: url("~@/assets/images/bg.png");
  background-color: #011040;
  background-size: 100% 100%;
  background-position: 100% 100%;
  background-repeat: no-repeat;

  .title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    .ai-icon {
      width: 32px;
      height: 31px;
      margin-right: 12px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/common/ai-icon.png");
    }
    .title-icon {
      width: 164px;
      height: 29px;
      background-size: 100% 100%;
      background-image: url("~@/assets/images/common/demand-title.png");
    }
  }

  .title-message {
    font-family: PingFang SC;
    margin-top: 18px;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    color: #ffffff;
    letter-spacing: 1px;
    opacity: 0.85;
    user-select: none;
  }

  .content-bg {
    width: 1080px;
    height: 450px;
    box-sizing: border-box;
    margin-top: 25px;
    padding: 20px;
    border: 1px solid #3D7BE1;
    border-radius: 12px;
    background: rgba(61, 123, 225, 0.2);
    box-shadow: 0 2px 8px 0 rgba(6, 40, 86, 0.06);

    .content-box {
      display: flex;
      justify-content: space-between;
      height: 100%;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 8px 0 rgba(6, 40, 86, 0.06);

      /deep/ .el-loading-mask {
        border-radius: 12px;
        cursor: not-allowed;
        .el-loading-spinner {
          display: none !important;
          svg {
            display: none !important;
          }
          .circular {
            width: 0 !important;
            height: 0 !important;
          }
        }
      }
    }

    .default-view, .disassembly-view {
      width: 100%;
      height: 408px;
      .input-content {
        width: 50%;
        height: 100%;
        padding: 20px 10px 20px 20px;
      }
    }

    .disassembly-view {
      /deep/ .el-textarea {
        height: calc(100% - 30px);
      }
      .back_radio {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 18px;
        padding-bottom: 12px;
        color: rgba(0, 0, 0, 0.45);

        .el-icon-arrow-left {
          left: -2px;
          top: 1px;
          font-size: 15px;
          user-select: none;
          z-index: 9;
        }

        .type-radio {
          user-select: none;
          span {
            color: rgba(0, 0, 0, 0.5);
            font-size: 15px;
            cursor: pointer;
          }
          i {
            color: #333333;
            font-size: 13px;
            font-style: normal;
            padding: 0 10px;
          }
          .active {
            font-weight: 500;
            color: rgb(2, 38, 224);
          }
        }
      }
    }

    .input-content {
      box-sizing: border-box;
      flex-shrink: 0;
      width: 50%;
      padding: 16px 20px 10px;
    }


    /deep/ .el-textarea {
      height: 100%;
    }

    /deep/ .el-textarea__inner {
      border: none;
      height: 100%;
      padding: 0;
      font-size: 16px !important;
      color: #000000;
      background: #ffffff;
      cursor: text;
    }
    .upload-file{
      width:  50%;
      height: calc(100% - 40px);
      padding: 20px 20px 20px 10px
    }
    .show-file {
      flex-shrink: 0;
      height: inherit;
      padding: 0 40px;
      .file-name {
        width: 350px;
        color: #666666;
        font-size: 14px;
        line-height: 16px;
        margin-top: 20px;
        cursor: default;
      }
      .upload-success {
        margin-top: 16px;
        font-size: 16px;
        color: rgba(0,194,124,0.9);
        cursor: default;
        i {
          color: inherit;
          margin-right: 2px;
        }
      }
      .operation-btn {
        margin-top: 12px;
        font-size: 14px;
        span+span {
          margin-left: 15px;
        }
        span {
          user-select: none;
          cursor: pointer;
          &:first-child {
            color: #1072EC;
          }
          &:last-child {
            color: tomato;
          }
        }
      }
    }
    /deep/.upload-demo{
      height: 100%;
      width: 100%;
      user-select: none;
    }
    /deep/.el-upload{
      height: 100%;
      width: 100%;
    }
    /deep/.el-upload-dragger{
      height: 100%;
      width: 100%;
    }
    .upload_text{
      color: #000000;
      font-size: 16px;
      margin-top: 15px;
      span{
        color: #1072EC;
        cursor: pointer;
      }
    }
    .upload-line{
      font-size: 14px;
      color: #000000;
      opacity: 0.65;
      justify-content: center;
      display: flex;
      align-items: center;
      margin-top: 35px;
      div{
        width: 60px;
        height: 1px;
        margin: 0 14px;
        opacity: 0.65;
        background-color: #000000;
      }
    }
    .upload-img{
      margin-top: 20px;
      height: 22px;
      display: flex;
      width: 190px;
      justify-content: space-between;
    }
  }

  .question-textarea {
    /deep/ .el-textarea {
      height: calc(100% - 40px) !important;
    }
  }

  .goDetails-btn{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .update-btn {
      font-weight: 400;
      font-size: 13px;
      /deep/ .el-button {
        padding: 0 !important;
        margin-left: 4px;
        span {
          font-size: 13px;
          font-weight: 400;
        }
      }
    }
    .submit-btn {
      /deep/ .el-button {
        display: flex;
        align-items: center;
        font-size: 13px !important;
        padding: 7px 13px !important;
        justify-content: center;
        background: #fff;
        color: #0226E0;
        border-color: #0226E0;
        border-radius: 16px !important;
        span {
          font-weight: 400;
        }
      }
    }
  }

  .upload-btn {
    width: 100%;
    color: #00000E85;
    display: flex;
    justify-content: end;

    /deep/ .el-button {
      color: #FFFFFF;
      border: none;
      padding: 0;
      background: #0226E0;
      font-size: 13px !important;
      border-radius: 16px !important;
      span {
        font-weight: 400;
      }
    }
    div{
      width: 200px;
      height: 44px;
      background: #464BFE;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: white;
    }
  }

  .upload-btn-primary {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 25px;

    /deep/ .el-button {
      width: 200px;
      height: 60px;
      color: #ffffff;
      background: #0D8AFF;
      border: none;
      border-radius: 30px !important;
      box-shadow: 0px -5px 12px 0px rgba(10,114,255,0.26), 0px 5px 12px 0px rgba(10,114,255,0.3);
    }
  }
}

/deep/.el-dialog{
  border-radius: 8px;
}

.update{
  /deep/.el-dialog{
    margin-top: 30vh !important;
  }
  /deep/.el-dialog__header{
    padding: 20px 20px 10px;
  }

  /deep/.el-dialog__body{
    padding: 20px 30px;
  }
}
/deep/.el-dialog__header{
  padding: 0;
}
/deep/.el-dialog__body{
  padding: 50px 30px;
}
.dialogTitle{
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 20px;
  color: #000000;
}

.item-data{
  background: #FFFFFF;
  border-radius: 4px;
  padding: 20px 22px;
  margin-top: 8px;
  border: 1px solid #DEE2E9;
  .fieldName{
    font-weight: 400;
    margin-left: 9px;
    font-size: 14px;
    color: #00000E65;
  }
  .field-keyword{
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    color: #00000E65;
    margin-top: 20px;

    .keyword-item{
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #464BFE;
      padding: 6px 11px;
      font-weight: 400;
      font-size: 14px;
      color: #464BFE85;
      margin-right: 8px;
    }
  }
}
.goDetails{
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  width: 200px;
  height: 44px;
  display: flex;
  margin-top: 60px;
  align-items: center;
  justify-content: center;
  background: #464BFE;
  border-radius: 22px;
  cursor: pointer;
}
.tips-field{
  margin-top: 17px;
  font-size: 14px;
  color: #00000E85;
}

.field-content{
  font-weight: 400;
  padding: 14px 0;
  font-size: 15px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.5);
}

.keyword-input {
  .keyword-box {
    width: 100%;
    display: flex;
    align-items: start;
    flex-wrap: wrap;
    height: auto;
    //min-height: 98px;
    min-height: 58px;
    overflow-y: auto;
    overflow-x: hidden;
    /deep/ .el-tg {
      max-width: 400px;
      margin-right: 10px;
      color: #0226E0;
      border-color: #0226E0;
      padding: 0 8px;
      margin-bottom: 6px;
      background: #FFFFFF;
      .el-tag__close {
        color: #0226E0;
        &:hover {
          color: #fff;
          background: rgba(2, 38, 224, 0.7);
        }
      }
    }

    .tag-item {
      position: relative;
      max-width: calc(100% - 38px);
      flex-shrink: 0;
      color: rgba(2, 38, 224, 0.85);
      font-size: 13px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #0226E0;
      padding: 1px 20px 1px 6px;
      margin-right: 8px;
      margin-bottom: 10px;
      border-radius: 4px;
      background: #FFFFFF;
      span {
        display: inline-block;
        width: 100%;
        overflow-x: auto;
        white-space: nowrap;

        &::-webkit-scrollbar {
          width: 2px;
          height: 2px;
        }
      }
      /deep/ .el-input__inner {
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        padding: 0 !important;
        border: none;
      }
      .el-icon-close {
        position: absolute;
        right: 3px;
        top: 0;
        vertical-align: top;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        &:hover {
          color: #0226E0;
        }
      }
    }

    .button-new-tag {
      display: inline-block;
      /deep/ .el-button {
        height: 28px;
        line-height: 28px;
        padding: 0 !important;
        span {
          font-size: 14px;
          color: #0226E0;
          font-weight: 400;
          white-space: nowrap;
        }
      }
    }
    .input-new-tag {
      width: 90px;
      /deep/ .el-input__inner {
        padding: 0 4px !important;
        &:focus {
          border-color: #0226E0;
        }
        &::placeholder {
          color: #999;
          font-size: 12px;
        }
      }
    }
    /deep/ .el-button {
      padding: 0 6px;
    }
    .operation-btn {
      font-size: 12px;
      line-height: 28px;
      margin-left: 4px;
    }
  }
  /deep/ .el-textarea {
    padding-top: 10px;
    height: 81px !important;

    /deep/ .el-textarea__inner {
      font-size: 12px !important;
    }
  }
}
</style>
